import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

interface AuthTokens {
  phone: string;
  accessToken: string;
  refreshToken: string;
}

interface BizResponse<T> {
  statusCode: number;
  data: T;
}

// POST /auth/login?phoneNumber=<phone>
export const sendOTP = (phone: string) => {
  const phoneNumber = encodeURIComponent(`+91${phone}`);
  return axios.post(`${BASE_URL}/admin/auth/login?phoneNumber=${phoneNumber}`);
};

// POST /auth/verify { phone, otp }
export const verifyOTP = (phone: string, otp: string) => {
  return axios.post<BizResponse<AuthTokens>>(`${BASE_URL}/admin/auth/verify`, {
    phone: `+91${phone}`,
    otp,
  });
};

// POST /auth/refresh { token }
export const refreshToken = (token: string) => {
  return axios.post<BizResponse<AuthTokens>>(`${BASE_URL}/admin/auth/refresh`, {
    token,
  });
};

const TOKEN_KEY = "auth_access_token";
const REFRESH_TOKEN_KEY = "auth_refresh_token";

export const getStoredAccessToken = (): string | null =>
  localStorage.getItem(TOKEN_KEY);
export const getStoredRefreshToken = (): string | null =>
  localStorage.getItem(REFRESH_TOKEN_KEY);

export const storeTokens = (access: string, refresh: string) => {
  localStorage.setItem(TOKEN_KEY, access);
  localStorage.setItem(REFRESH_TOKEN_KEY, refresh);
};

export const clearTokens = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
};
